export enum KeycloakLoginTypes {
  LOGIN = 'LOGIN',
  LOGIN_ERROR = 'LOGIN_ERROR',
  LOGOUT = 'LOGOUT',
  LOGOUT_ERROR = 'LOGOUT_ERROR',
}

export enum KeycloakResourceTypes {
  GROUP = 'GROUP',
  USER = 'USER',
  ROLE = 'CLIENT_ROLE',
}

export enum KeycloakOperationType {
  ACTION = 'ACTION',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
}
